import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import IconInformationCircle from '@/assets/icons/heroIcons/InformationCircle.svg';
import IconCheck from '@/assets/icons/heroIcons/Circle-check.svg';
import IconCross from '@/assets/icons/heroIcons/Circle-cross.svg';
import { Tooltip } from '@/components/Tooltip';
import { TabsButtons } from '@/components/buttons';
import { mergeClasses } from '@/utils/style';
interface CategoryItem {
  title: string | React.JSX.Element;
  tooltip?: string;
  left: string | boolean;
  center: string | boolean;
  right: string | boolean;
}
interface Category {
  title: string;
  tooltip?: string;
  items: CategoryItem[];
}
interface Props {
  titles: {
    left: string;
    center: string;
    right: string;
  };
  categories: Category[];
  activeColumn?: 'left' | 'center' | 'right';
  headerClassName?: string;
  coloredHeaderBgClassName?: string;
  primaryColumn?: number;
  footer?: {
    title: string | React.JSX.Element;
    left: string | boolean;
    center: string | boolean;
    right: string | boolean;
  };
  badge?: string;
}
function Answer(t0) {
  const $ = _c(7);
  const {
    content,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("flex shrink-0 items-center justify-end pr-6 md:w-52 md:justify-center md:pr-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== content) {
    t2 = typeof content === "string" ? <b className="font-semibold">{content}</b> : content ? <IconCheck /> : <IconCross />;
    $[2] = content;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function ProductComparisonTable(t0) {
  const $ = _c(72);
  const {
    titles,
    categories,
    activeColumn: t1,
    headerClassName,
    coloredHeaderBgClassName,
    primaryColumn: t2,
    footer,
    badge
  } = t0;
  const initialActiveColumn = t1 === undefined ? "left" : t1;
  const primaryColumn = t2 === undefined ? 1 : t2;
  const [activeColumn, setActiveColumn] = useState(initialActiveColumn);
  let t3;
  if ($[0] !== badge) {
    t3 = badge && <div className="mt-4 h-24 w-25 -rotate-[15deg] rounded-full bg-red-500 p-2 text-center text-base font-semibold text-white md:hidden">{badge}</div>;
    $[0] = badge;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setActiveColumn("left");
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== titles.left) {
    t5 = {
      id: "left",
      label: titles.left,
      onClick: t4
    };
    $[3] = titles.left;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setActiveColumn("center");
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== titles.center) {
    t7 = {
      id: "center",
      label: titles.center,
      onClick: t6
    };
    $[6] = titles.center;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setActiveColumn("right");
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== titles.right) {
    t9 = {
      id: "right",
      label: titles.right,
      onClick: t8
    };
    $[9] = titles.right;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t7 || $[13] !== t9) {
    t10 = [t5, t7, t9];
    $[11] = t5;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== activeColumn || $[16] !== t10) {
    t11 = <div className="w-full md:hidden"><TabsButtons id="comparasionTabs" activeTab={activeColumn} tabs={t10} /></div>;
    $[15] = activeColumn;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== badge) {
    t12 = badge && <div className="absolute -top-3 left-5 z-10 hidden h-24 w-25 -rotate-[15deg] rounded-full bg-red-500 p-2 text-center text-base font-semibold text-white md:block">{badge}</div>;
    $[18] = badge;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== primaryColumn) {
    t13 = mergeClasses("absolute -top-4 -bottom-4 z-0 hidden w-52 overflow-hidden rounded-3xl bg-white md:block", {
      "right-52": primaryColumn === 1
    }, {
      "right-0": primaryColumn === 2
    });
    $[20] = primaryColumn;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== coloredHeaderBgClassName) {
    t14 = mergeClasses("h-26 w-full", coloredHeaderBgClassName);
    $[22] = coloredHeaderBgClassName;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <div className={t14} />;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = <div className={t13}>{t15}</div>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = badge !== undefined;
  let t18;
  if ($[29] !== t17) {
    t18 = mergeClasses("relative hidden flex-row items-center text-xl md:flex md:pb-7", {
      "md:pb-[5.25rem]": t17
    });
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="w-full flex-shrink-1 px-8 py-2" />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  const t20 = titles.left;
  let t21;
  if ($[32] !== headerClassName) {
    t21 = mergeClasses("px-4! text-center", headerClassName);
    $[32] = headerClassName;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t21 || $[35] !== titles.left) {
    t22 = <Answer content={t20} className={t21} />;
    $[34] = t21;
    $[35] = titles.left;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = titles.center;
  let t24;
  if ($[37] !== headerClassName) {
    t24 = mergeClasses("px-4! text-center text-blue-500", headerClassName);
    $[37] = headerClassName;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t24 || $[40] !== titles.center) {
    t25 = <Answer content={t23} className={t24} />;
    $[39] = t24;
    $[40] = titles.center;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  const t26 = titles.right;
  let t27;
  if ($[42] !== headerClassName) {
    t27 = mergeClasses("px-4! text-center", headerClassName);
    $[42] = headerClassName;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t27 || $[45] !== titles.right) {
    t28 = <Answer content={t26} className={t27} />;
    $[44] = t27;
    $[45] = titles.right;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t18 || $[48] !== t22 || $[49] !== t25 || $[50] !== t28) {
    t29 = <div className={t18}>{t19}{t22}{t25}{t28}</div>;
    $[47] = t18;
    $[48] = t22;
    $[49] = t25;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== activeColumn || $[53] !== categories) {
    let t31;
    if ($[55] !== activeColumn) {
      t31 = category => <div key={category.title} className="relative"><div className="flex flex-col gap-3 md:gap-4"><p className="px-6 text-lg font-semibold md:px-8 md:text-xl"><span>{category.title}</span>{category.tooltip && <span className="relative top-1 ml-2 inline-block text-base font-normal md:text-base"><Tooltip tooltip={category.tooltip} trigger={["hover", "click", "focus"]}><span className="text-light-gray-500 inline-block"><IconInformationCircle /></span></Tooltip></span>}</p>{category.items.map(item => <div className="relative flex flex-row items-center justify-between md:justify-normal" key={item.title.toString()}><div className="max-w-[240px] flex-auto px-6 md:max-w-none md:px-8"><span className="text-base break-words">{item.title}{item.tooltip && <span className="relative top-1 ml-2 inline-block"><Tooltip tooltip={item.tooltip}><span className="text-light-gray-500 inline-block"><IconInformationCircle /></span></Tooltip></span>}</span></div><Answer content={item.left} className={mergeClasses(activeColumn !== "left" && "hidden md:flex")} /><Answer content={item.center} className={mergeClasses(activeColumn !== "center" && "hidden md:flex")} /><Answer content={item.right} className={mergeClasses(activeColumn !== "right" && "hidden md:flex")} /></div>)}</div></div>;
      $[55] = activeColumn;
      $[56] = t31;
    } else {
      t31 = $[56];
    }
    t30 = categories.map(t31);
    $[52] = activeColumn;
    $[53] = categories;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[57] !== activeColumn || $[58] !== footer) {
    t31 = footer && <div className="flex flex-row gap-2 md:gap-4"><div className="w-full flex-shrink-1 px-6 md:px-8"><p className="text-lg font-semibold md:text-xl">{footer.title}</p></div><div className="relative flex flex-row items-center justify-center"><Answer content={footer.left} className={mergeClasses(activeColumn !== "left" && "hidden md:flex")} /><Answer content={footer.center} className={mergeClasses(activeColumn !== "center" && "hidden md:flex")} /><Answer content={footer.right} className={mergeClasses(activeColumn !== "right" && "hidden md:flex")} /></div></div>;
    $[57] = activeColumn;
    $[58] = footer;
    $[59] = t31;
  } else {
    t31 = $[59];
  }
  let t32;
  if ($[60] !== t30 || $[61] !== t31) {
    t32 = <div className="flex flex-col gap-6 md:gap-8">{t30}{t31}</div>;
    $[60] = t30;
    $[61] = t31;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== t12 || $[64] !== t16 || $[65] !== t29 || $[66] !== t32) {
    t33 = <div className="w-full md:py-4"><div className="relative mx-auto max-w-[70rem] rounded-xl bg-white pt-6 pb-7 md:rounded-3xl md:bg-blue-50">{t12}{t16}{t29}{t32}</div></div>;
    $[63] = t12;
    $[64] = t16;
    $[65] = t29;
    $[66] = t32;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== t11 || $[69] !== t3 || $[70] !== t33) {
    t34 = <div className="relative flex flex-col items-center gap-6">{t3}{t11}{t33}</div>;
    $[68] = t11;
    $[69] = t3;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  return t34;
}
export default ProductComparisonTable;